export type ComparisonOffer = {
  id: string; product_id: string; brand_id: string; price: number; shipping: number | null;
  checked_at: string; image_url: string; deeplink: string;
  brand: { name: string; slug: string; logo_url: string | null; commission_type: string | null; donation_percentage: number | null; affiliate_network: string | null };
};
export type ComparisonProduct = {
  id: string; slug?: string | null; category_id?: string | null; gtin: string; title: string; manufacturer: string; model: string | null;
  variant: string; image_url: string | null; category_name: string | null;
  store_count?: number;
  specs?: Record<string, string> | null;
  drop?: number;
  offers: ComparisonOffer[];
};

export const money = (value: number) => new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(value);

// Doação estimada = preço × percentual de doação exibido na página da loja (apenas CPS).
export function impact(offer: ComparisonOffer): number | null {
  const pct = Number(offer.brand.donation_percentage);
  if (offer.brand.commission_type !== 'percentage' || !(pct > 0)) return null;
  return Math.round(offer.price * pct) / 100;
}

export function validGtin(raw: string): string | null {
  const digits = raw.replace(/\D/g, '');
  if (![8, 12, 13, 14].includes(digits.length) || /^([0-9])\1+$/.test(digits)) return null;
  const reversed = digits.slice(0, -1).split('').reverse();
  const sum = reversed.reduce((total, d, i) => total + Number(d) * (i % 2 === 0 ? 3 : 1), 0);
  return (10 - sum % 10) % 10 === Number(digits.at(-1)) ? digits : null;
}

// Mesmo GTIN não basta para juntar variantes com nomes conflitantes.
export function normalizedVariant(title: string): string {
  return title.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase()
    .replace(/\b(kit|pack|combo|unidades?|pares?|pecas?)\b/g, ' $1 ')
    .replace(/[^a-z0-9]+/g, ' ').trim().replace(/\s+/g, ' ').slice(0, 170);
}
/** "Preço verificado hoje às 14:20" ou "Preço verificado em 06/10 às 14:20" (horário de Brasília). */
export function verifiedLabel(date: string) {
  const tz = 'America/Sao_Paulo';
  const d = new Date(date);
  const day = (x: Date) => new Intl.DateTimeFormat('pt-BR', { dateStyle: 'short', timeZone: tz }).format(x);
  const time = new Intl.DateTimeFormat('pt-BR', { hour: '2-digit', minute: '2-digit', timeZone: tz }).format(d);
  return day(d) === day(new Date()) ? `Preço verificado hoje às ${time}` : `Preço verificado em ${new Intl.DateTimeFormat('pt-BR', { day: '2-digit', month: '2-digit', timeZone: tz }).format(d)} às ${time}`;
}
